import { FC } from 'react';
import { useAtomValue } from 'jotai';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { useTranslation } from 'react-i18next';
import { ImageRegion } from '../constants';

const url = 'https://www.lemon8-app.com/activity/100-things';

const OG: FC = () => {
  const { region } = useAtomValue($Locale);
  const { t } = useTranslation();

  const title = t('bucketList_landingPage_header');
  const desc = t('bucketList_share_desc');
  const image = ImageRegion[region] || ImageRegion.default;

  return (
    <>
      <meta property="og:url" content={`${url}?region=${region}`} />
      <meta property="og:type" content="article" />

      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1920" />
      <meta property="og:image:height" content="1080" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lemon8" />
      <meta name="twitter:text:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      <meta key="og:title" property="og:title" content={title} />
      <meta key="og:description" property="og:description" content={desc} />
    </>
  );
};

export default OG;
